import Vue from 'vue'
import VueRouter from 'vue-router'
import ListePhoto from '@/views/ListePhoto'
import MainPage from '@/views/MainPage'
import HelloWorld from '@/views/HelloWorld'
import Calendrier from '@/views/Calendrier'
import Contacts from '@/views/Contacts'
import Planning from '@/views/Planning'
import Login from '@/views/Login'
import { auth } from '../firebase'
import Alltcs from '@/views/Alltcs'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Calendrier'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
    // component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: '/liste-photo',
    name: 'ListePhoto',
    component: ListePhoto,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Calendrier',
    name: 'Calendrier',
    component: Calendrier,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Contacts',
    name: 'Contacts',
    component: Contacts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Planning',
    name: 'Planning',
    component: Planning,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/main-page',
    name: 'MainPage',
    component: MainPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hello-world',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/Alltcs', // Ajout de la route pour Alltcs
    name: 'Alltcs',
    component: Alltcs,
    meta: {
      requiresAuth: true // Ajoutez cette ligne si l'authentification est nécessaire
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// navigation guard to check for logged in users

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!auth.currentUser) {
      next({ name: 'Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js